import { CouponInfo, CouponType, ThemeColor, getValidCurrencyType } from '@tencent/wphk-act-base-ui';
import { ICashCouponInfo } from '../type';
import { getButtonType, getCouponBtnText, getFormattedDiscount, getIsShowButton, getPkgCouponInfo, getStampText, getTipsLeftConfig, getTipsTextRight, isCouponBackgroundDisabled } from '../utils/ui-formatter';
import { getTipsTextRightV2 } from '../utils/ui-formatter-v2';
import { UtilsTypes } from '@tencent/wphk-act-base-types';

/** 适配现金优惠券 */
export const adaptCashCouponInfo = (
  couponLang: UtilsTypes.LanguageTypeEnum,
  coupon: ICashCouponInfo,
  extraParams: Partial<CouponInfo> = {},
  version = 1, // 版本 1 和版本 2
): CouponInfo => {
  let userCouponInfo = {};
  const {
    mrchLogo,
    couponName,
    couponDesc,
    discount,
    mrchName,
    isPkgCoupon,
    isChainCoupon,
    couponType,
    goodsUrl,
    currencyType,
  } = coupon;
  const tipsTextRight = version === 1 ? getTipsTextRight(coupon) : getTipsTextRightV2(coupon);
  const formattedExtraParams = {
    couponType: couponType || CouponType.cash,
    prizeLogo: mrchLogo,
    spLogo: mrchLogo,
    spDesc: mrchName,
    prizeName: couponName,
    prizeDesc: couponDesc,
    themeColor: ThemeColor.green,
    prizeAmountYuan: discount,
    prizeDiscount: getFormattedDiscount(coupon, couponLang), // 处理英文-20%off
    isShowButton: getIsShowButton(coupon),
    couponBtnText: getCouponBtnText(coupon),
    isChain: isPkgCoupon || isChainCoupon,
    isExpire: isCouponBackgroundDisabled(coupon.couponState),
    ...getTipsLeftConfig(coupon),
    ...getPkgCouponInfo(coupon.isPkgCoupon, coupon.pkgCount),
    tipsTextRight,
    goodsUrl: goodsUrl || '', // 货物图片，竖状券需要
    currencyType: getValidCurrencyType(currencyType),
  };
  const stampText = getStampText(coupon, coupon.lang);
  userCouponInfo = {
    isShowStamp: stampText,
    stampText,
    buttonType: getButtonType(coupon),
  };
  const returnCoupon: CouponInfo = { ...coupon, ...formattedExtraParams, ...userCouponInfo, ...extraParams };
  return returnCoupon as CouponInfo;
};
